import { render, staticRenderFns } from "./ImgUpload.vue?vue&type=template&id=52c68816&scoped=true&"
import script from "./ImgUpload.vue?vue&type=script&lang=js&"
export * from "./ImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImgUpload.vue?vue&type=style&index=0&id=52c68816&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c68816",
  null
  
)

export default component.exports